<template lang="pug">
  .invoice-item(:class="{ 'extra-height': productData.qty }")
    slot(name="top")
    .image-wrap.xs-4.md-12
      ProductInfoImage(:imagery="productData.imagery")
    .info-wrap.xs-8.md-12
      .xs-10.md-12.lg-12
        p.semi-bold.upper.xs-f-xsmall.max-at-tweak {{ productData.productType || productData.product_type_display_name }}
        p.color-slate.xs-f-xsmall.max-at-tweak {{ productData.name }}

      .pill-wrap
        template(v-if="pillText")
          Pill(:text="pillText" data-mr-ass="order-subscription")

      slot(name="bottom")

</template>

<script>
  import { mapState } from 'vuex';
  import ProductInfoImage from "../../../Purchases/ProductInfoImage";
  import Pill from "../../../../Pill";

  export default {
    name: "InvoiceItem",
    components: {
      Pill,
      ProductInfoImage
    },

    props: {
      item: {
        type: Object,
        required: true
      }
    },

    computed: {
      ...mapState('constants', ['invoiceItemTags']),

      productData() {
        return this.item.product ? this.item.product : this.item;
      },

      pillText() {
        let text;

        if (this.item.subscription || this.item.frequency) {
          text = this.invoiceItemTags.sub;
        } else if (this.item.sub_id || this.item.subscription_id) {
          text = this.invoiceItemTags.sub_addon;
        }

        return text;
      }
    }
  }
</script>

<style scoped lang="stylus">
  .invoice-item
    position relative

  @media mq-tablet-less
    .invoice-item
      padding-bottom 1.5em

      .info-wrap
        padding-left 0.75em

        p
          padding-bottom 0.25em

  @media mq-desktop-md
    .invoice-item
      width 12em
      margin-right 1em
      min-height 18em

      .info-wrap
        padding-top 0.5em

  @media mq-desktop-plus
    .invoice-item
      width 12em
      margin-right 1.5em
      min-height 19em

      &.extra-height
        min-height 23em

      .info-wrap
        padding-top 0.5em

</style>
